import { environment } from 'src/environments/environment';
import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
// [[PrimeNg]]
import { MessageService } from 'primeng/api';
// [[Providers]]
import { SEO } from '~project/shared/services/SEO/service';
import { CustomerUserService } from 'src/project/services/panel/client/marketplace/customer/user/user.service';
import { CollectiveMarketplaceService } from '~services/collective/client/marketplace/marketplace.service';
import { CollectiveMarketplaceCartService } from '~services/collective/client/marketplace/cart/cart.service';
import { CollectiveMarketplaceCoreVisualBannerService } from '~services/collective/client/marketplace/core/visual/banner/banner.service';

import { ClientMarketplaceCoreProductService } from '~services/collective/client/marketplace/core/product/product.service';
import { CustomerProductAnalyticActionService } from '~services/panel/client/marketplace/customer/product/analytic/action.service';
// ]
// [[Interfaces/Models do Componente]]

// ]
// [[Functions]]

// ]
@Component({
  selector: 'app',
  templateUrl: './component.html',
  styleUrls: ['./component.scss'],
})
export class HomeComponent implements OnInit {
  /**
   * Base de uso em Component
   */
  public environment = environment;
  messageProcess = false;
  messageIsError: any;
  profile: any;
  marketplace: any = null;
  cart: any = null;
  banners: any = null;
  banners_fnc_cta: any = null;

  actualUrl: any = this.router.url;

  constructor(
    /**
     * Serviços da Aplicação
     */
    private titleService: Title,
    private SEO: SEO,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    /**
     * PrimeNg
     */
    private messageService: MessageService,
    /**
     * Base de uso em Component
     */
    private userService: CustomerUserService,
    private collectiveMarketplaceService: CollectiveMarketplaceService,
    private collectiveMarketplaceCartService: CollectiveMarketplaceCartService,
    private collectiveMarketplaceCoreVisualBannerService: CollectiveMarketplaceCoreVisualBannerService,
    /**
     * Services
     */
    private clientMarketplaceCoreProductService: ClientMarketplaceCoreProductService,
    private customerProductAnalyticActionService: CustomerProductAnalyticActionService
  ) {}

  /**
   * on init
   */
  ngOnInit() {
    this.ipBuildEcommerceDependencies();
    this.ipBuildSeoDependencies();
  }

  /**
   * build ecommerce dependencies
   */
  ipBuildEcommerceDependencies() {
    /**
     * Base
     *
     * Request da base de uso.
     */
    // PROFILE
    this.userService.getUser().subscribe((Profile: any) => {
      if (Profile != null) {
        if (JSON.parse(Profile) != null) {
          this.profile = JSON.parse(Profile);
        }
      }
    });
    // MARKETPLACE
    this.collectiveMarketplaceService.getMarketplace().subscribe((Marketplace: any) => {
      if (Marketplace != null) {
        if (JSON.parse(Marketplace) != null) {
          this.marketplace = JSON.parse(Marketplace);
          /**
           *
           * CONFIGURAÇÕES ADICIONAIS DESTE `COMPONENTE`
           *
           */
          // SEO
          this.titleService.setTitle(this.marketplace.name);
        }
      }
    });
    // CART
    this.collectiveMarketplaceCartService.getCart().subscribe((Cart: any) => {
      if (Cart != null) {
        if (JSON.parse(Cart) != null) {
          this.cart = JSON.parse(Cart);
        }
      }
    });
    // BANNERS
    this.banners_fnc_cta = function (banner: any) {
      if (banner.url != '') {
        document.location = banner.url;
      }
      return false;
    };
    this.collectiveMarketplaceCoreVisualBannerService.getBanners().subscribe((Data: any) => {
      if (Data != null) {
        if (JSON.parse(Data) != null) {
          this.banners = JSON.parse(Data);
        }
      }
    });
  }

  /**
   * build SEO dependencies
   */
  ipBuildSeoDependencies() {
    /**
     * Base
     *
     * Request da base de uso.
     */
    this.SEO.setTitle({
      title: 'Casa de Gê Oficial - Casa de Gê',
    });
    this.SEO.setMeta({
      keywords: 'Produtos de Limpeza, KIT de Limpeza, KIT, Sem Passar, Baby Soft, Cuidados com a Casa, Dicas de Limpeza',
      description: 'Você já conhece os produtos da @casadege? As melhores ✨ marcas para cuidados e limpezas com a casa.',
      og_url: '',
      og_title: '',
      og_type: '',
      og_description: '',
      og_image: '',
    });
  }

  ngAfterViewInit() {
    this.customerProductAnalyticActionServiceIndex({ client_marketplace_id: 1, per_page: 5, page: 1 });
    this.clientMarketplaceCoreProductServiceIndex();
    this.clientMarketplaceCoreProductServiceBestSellerIndex();
    this.clientMarketplaceCoreProductServiceReleaseIndex();
  }

  ngOnDestroy() {}

  products0st: any;
  customerProductAnalyticActionServiceIndex(params: any) {
    this.messageProcess = true;
    var _ = this.customerProductAnalyticActionService.index(params);
    if (_ !== null) {
      _.subscribe(
        (response: any) => {
          this.messageProcess = false;
          this.products0st = response.data;
        },
        () => {}
      );
    }
  }

  products1st: any;
  clientMarketplaceCoreProductServiceIndex() {
    this.messageProcess = true;
    var _ = this.clientMarketplaceCoreProductService.index({ client_marketplace_id: 1, per_page: 10, page: 1, category: 'Queridinhos' });
    if (_ !== null) {
      _.subscribe(
        (response: any) => {
          this.messageProcess = false;
          this.products1st = response.data;
        },
        (err) => {
          if (err.error.errors) {
            for (let error in err.error.errors) {
              this.messageService.add({ severity: 'error', detail: err.error.errors[error] });
              this.messageProcess = false;
              this.messageIsError = this.clientMarketplaceCoreProductService.error.throw(error);
            }
          }
        }
      );
    }
  }

  products2n: any;
  clientMarketplaceCoreProductServiceBestSellerIndex() {
    this.messageProcess = true;
    var _ = this.clientMarketplaceCoreProductService.index({ client_marketplace_id: 1, per_page: 10, page: 1, best_seller: 'yes' });
    if (_ !== null) {
      _.subscribe(
        (response: any) => {
          this.messageProcess = false;
          this.products2n = response.data;
        },
        (err) => {
          if (err.error.errors) {
            for (let error in err.error.errors) {
              this.messageService.add({ severity: 'error', detail: err.error.errors[error] });
              this.messageProcess = false;
              this.messageIsError = this.clientMarketplaceCoreProductService.error.throw(error);
            }
          }
        }
      );
    }
  }

  products3th: any;
  clientMarketplaceCoreProductServiceReleaseIndex() {
    this.messageProcess = true;
    var _ = this.clientMarketplaceCoreProductService.index({ client_marketplace_id: 1, per_page: 10, page: 1, product_is_release: 'yes' });
    if (_ !== null) {
      _.subscribe(
        (response: any) => {
          this.messageProcess = false;
          this.products3th = response.data;
        },
        (err) => {
          if (err.error.errors) {
            for (let error in err.error.errors) {
              this.messageService.add({ severity: 'error', detail: err.error.errors[error] });
              this.messageProcess = false;
              this.messageIsError = this.clientMarketplaceCoreProductService.error.throw(error);
            }
          }
        }
      );
    }
  }
}
